<template>
	<div class="comp">
		<el-dialog :visible.sync="dialog_state" width="600px" :show-close="false" :close-on-click-modal='false'>
			<div class="dialog">
				<div class="title">赠送优惠券</div>
				<div class="content">
					<el-row style="padding:30px 0 20px;font-size: 18px;">
						<el-col>当前充值金额是 <span style="color:red">{{row.price}}</span> 元，
						赠送 <span style="color:red">{{this.dictionary[this.row.price].num}}</span> 张优惠券。</el-col>
					</el-row>
					<el-row style="padding:0 0 10px 0;">
						<el-col>请选择优惠券类型：</el-col>
					</el-row>
					<el-row style="padding:10px 0 8px 20px;" >
						<el-col :span="22">
							{{dictionary[row.price].type}} ( 美容卡 ) 
							<span style="padding:0 30px">x</span>
							<el-input v-model="num1" @input="changeNum1" style="width:50px;margin-left:5px;" class="inputNum"></el-input> 张
						</el-col>
					</el-row>
					<el-row style="padding:8px 0 5px 20px;" >
						<el-col :span="22">
							{{dictionary[row.price].type}} ( 医疗卡 ) 
							<span style="padding:0 30px">x</span>
							<el-input step="1" v-model="num2" @input="changeNum2" style="width:50px;margin-left:5px;" class="inputNum"></el-input> 张
						</el-col>
					</el-row>
					<el-form :inline="true" style="padding-top:30px;">
						<el-row>
							<el-col>
								<el-form-item label="备注：" :label-width="formLabelWidth">
									<el-input type="textarea" v-model="remark" :rows="1" style="width:300px"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form>
				</div>
				<span slot="footer" style="text-align: right;display: block;padding-top:20px;">
					<el-button @click="submit('close')">取 消</el-button>
					<el-button type="primary" @click="submit('success')">确 定</el-button>
				</span>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				dialog_state: true,
				formLabelWidth: '55px',
				
				remark:'',
				num1:'1',
				num2:'1',
				
				dictionary:{
					'1000':{num:2,type:'满100减50',meirong:'5fae433d5e7314393508f20a',yiliao:'5fae43a85e7314393508f20f'},
					'3000':{num:8,type:'满200减100',meirong:'5fae43e25e7314393508f21b',yiliao:'5fae44035e7314393508f21e'},
					'5000':{num:10,type:'满200减100',meirong:'5fae43e25e7314393508f21b',yiliao:'5fae44035e7314393508f21e'},
					'10000':{num:10,type:'满200减100',meirong:'5fae43e25e7314393508f21b',yiliao:'5fae44035e7314393508f21e'},
					'30000':{num:20,type:'满200减100',meirong:'5fae43e25e7314393508f21b',yiliao:'5fae44035e7314393508f21e'}
				}
			}
		},
		props:{
			row:{
				default:()=>{
					return {}
				}
			}
		},
		watch:{
			num1(n,o){
				if(String(n).indexOf('.')>-1){
					this.num1 = o;
				}
			},
			num2(n,o){
				if(String(n).indexOf('.')>-1){
					this.num2 = o;
				}
			},
		},
		created(){
			for(let key in this.dictionary){
				if(key===String(this.row.price)){
					this.num1 = this.dictionary[key].num/2
					this.num2 = this.dictionary[key].num/2
				}
			}
		},
		mounted() {
			
		},
		methods: {
			changeNum1(){
				this.num2 = this.dictionary[this.row.price].num-Number(this.num1)
			},
			changeNum2(){
				this.num1 = this.dictionary[this.row.price].num-Number(this.num2)
			},
			submit(type){
				if(type==="close"){
					this.$emit("submit",'close')
				}else if(type==='success'){
					let loading=this.$loading();
					if(Number(this.num1)<0){
						this.$message({
							message: '赠送的美容券数量有误',
							type: 'error'
						});
						loading.close();
						return ;
					}
					if(Number(this.num2)<0){
						this.$message({
							message: '赠送的医疗券数量有误',
							type: 'error'
						});
						loading.close();
						return ;
					}
					if(Number(this.num1)+Number(this.num2)!==this.dictionary[this.row.price].num){
						this.$message({
							message: '赠送的优惠券总数量有误',
							type: 'error'
						});
						loading.close();
						return ;
					}
					let coupon_list = [
						{
							coupon_id:this.dictionary[this.row.price].meirong,
							coupon_count:Number(this.num1)
						},
						{
							coupon_id:this.dictionary[this.row.price].yiliao,
							coupon_count:Number(this.num2)
						}
					]
					let params = {
						member_id:this.row.user_info.user_id,
						member_name:this.row.user_info.nick_name,
						member_mobile:this.row.user_info.user_mobile,
						order_id:this.row._id,
						other_param:this.row._id,
						"remark": this.remark,
						coupon_list:coupon_list,
					}
					this.$http.post('/api/Member/RechargeGiveCoupon', params).then(res => {
						loading.close();
						if (res.code == 0) {
							this.$message({
								message: '操作成功',
								type: 'success'
							});
							this.$emit('submit','success')
						}
					})
				}
			},
			
		}
	}
</script>
<style lang="scss" scoped>
	.comp {
		::v-deep .el-dialog__body {
			padding-top: 0;
		}

		.dialog {
			font-size: 16px;

			.title {
				color: #1A1A1A;
				font-size: 18px;
				padding: 0 20px 20px 20px;
				border-bottom: 1px solid #979797;
			}

			.content {
				padding: 0 30px 0 30px;
				.inputNum{
					::v-deep .el-input__inner{
						height: 31px;
						line-height: 30px;
						text-align: center;
					}
				}
			}
		}
	}
</style>
